import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS } from "../../../../globals";

@Component({
  selector: 'modify-staff',
  templateUrl: '../../templates/partials/modify-staff.html'
})
export class ModifyStaffComponent implements OnInit{
  public editStaff = false;
  public createUser: FormGroup;
  @Input() staffSelected;
  @Output() modifyStaffEmitter = new EventEmitter();
  constructor(private _fb: FormBuilder){}

  public removeManagerUser(){


    this.editStaff = false;
    this.modifyStaffEmitter.emit({action:"remove", id: this.staffSelected["id"]});
    this.emptyForm();
  }

  public updateManagerUser(){

    this.staffSelected["name"] = this.createUser.controls.name.value;
    this.staffSelected["surname"] = this.createUser.controls.surname.value;
    this.staffSelected["email"] = this.createUser.controls.email.value;
    this.staffSelected["role"] = this.createUser.controls.role.value;

    this.modifyStaffEmitter.emit({action:"update", data: this.staffSelected});
    //console.log(this.modifyStaffEmitter);
  }

  public createManagerUser(){
    var createStaff = {
      name: this.createUser.controls.name.value,
      surname: this.createUser.controls.surname.value,
      email: this.createUser.controls.email.value,
      role: this.createUser.controls.role.value
    }
    this.emptyForm();
    this.modifyStaffEmitter.emit({action:"create", data: createStaff});
  }

  public emptyForm() {
    this.createUser.setValue({
        name: '',
        surname: '',
        email: '',
        role: '' 
      });
  }

  ngOnChanges(changes: any){
    if(!changes["staffSelected"]["firstChange"]){
      if(changes["staffSelected"]["currentValue"] != null){
        this.createUser.setValue({
          name: changes["staffSelected"]["currentValue"]["name"],
          surname: changes["staffSelected"]["currentValue"]["surname"],
          email:changes["staffSelected"]["currentValue"]["email"],
          role: changes["staffSelected"]["currentValue"]["role"] 
        });
        this.editStaff = true;
      }else{
        this.emptyForm();
        this.editStaff = false;
      }
    }
  }

  ngOnInit() {
    this.createUser = this._fb.group({
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            email: ['', [Validators.required,Validators.pattern(PATTERNS["email"])]],
            role: ['', [Validators.required]],
        });
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/staff/components/dummy/modify-staff.component.ts